import React, { useState, useEffect } from 'react';
import Scroll from './Scroll';
import config from '../../config';
import logoBlue from '../assets/img/logo.png';
import logoWhite from '../assets/img/logoWhite.png';
import { Link } from "gatsby";



const Header = ({ frontPage=true, ...props }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [visibilityClass, setVisibilityClass] = useState('');

  const toggleMenu = value => {
    setOpenMenu(value);
  };
  const handleScroll= function(){
    if (window.pageYOffset > 300) {
      setVisibilityClass('navbar-shrink');
    } else {
      setVisibilityClass('');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, [])


    return (
      <nav
        className={`navbar navbar-expand-lg navbar-light fixed-top ${visibilityClass}`}
        id="mainNav"
      >
        <div className="container">
          <a className="navbar-brand" href={`${config.url}${config.pathPrefix}`}>
            <img src={visibilityClass ? logoBlue : logoWhite} className="logo" alt={`${config.heading}`} />
            <img src={logoBlue} className="logo responsive" alt={`${config.heading}`} />
          </a>
          <button
            onClick={_ => toggleMenu(!openMenu)}
            className={`navbar-toggler navbar-toggler-right ${
              openMenu ? '' : 'collapsed'
              }`}
            type="button"
            aria-controls="navbarResponsive"
            aria-expanded={openMenu}
            aria-label="Toggle navigation"
          >
            Menu
            <i className="fas fa-bars"></i>
          </button>
          <div
            className={`collapse navbar-collapse ${openMenu ? 'show' : ''}`}
            id="navbarResponsive"
          >
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
               { frontPage?<Scroll
                  onClick={_ => toggleMenu(!openMenu)}
                  type="id"
                  element="about"
                >
                  <a className="nav-link" href="#about">
                    About
                  </a>
                </Scroll> : <Link className="nav-link" to={`${config.url}${config.pathPrefix}#about`}>
                    About
                  </Link>}
              </li>
              <li className="nav-item">
                {frontPage? <Scroll
                  onClick={_ => toggleMenu(!openMenu)}
                  type="id"
                  element="blog"
                >
                  <a className="nav-link" href="#blog">
                    Blog
                  </a>
                </Scroll> : <a className="nav-link" href={`${config.url}${config.pathPrefix}/blog`}>
                    Blog
                  </a>
                }
              </li>
              <li className="nav-item">
                {frontPage ? <Scroll
                  onClick={_ => toggleMenu(!openMenu)}
                  type="id"
                  element="contacts"
                >
                  <a className="nav-link" href="#contacts">
                    Contact
                  </a>
                </Scroll> : <Link className="nav-link" to={`${config.url}${config.pathPrefix}#contacts`}>
                    Contact
                  </Link>
                }
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }

  export default Header;